import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledTextArea = styled.textarea`
  font-family: 'Open Sans', sans-serif;
  font-size: 16px;
  letter-spacing: -0.4px;
  outline: none;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  color: #383C42;
  border: 1px solid #cac8c8;
  border-radius: 4px;
  font-weight: normal;
  padding: 16px;
  resize: none;

  &::placeholder {
    letter-spacing: 0.2px;
    color: #6C727F;
  }

  &::-moz-placeholder {
    line-height: 45px;
  }

  &:disabled {
    background: rgba(0, 0, 0, 0.1);
  }
`;

const TextArea = ({ value, ...props }) => <StyledTextArea {...props} value={value || ''} />;

TextArea.defaultProps = {
  value: null,
};

TextArea.propTypes = {
  value: PropTypes.string,
};

export default TextArea;
